<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-md-6">
      <div class="card shadow-lg rounded">
        <div class="card-header text-center bg-dark text-primary">
          <h3>{{ 'FORGET_PASSWORD_TITLE' | translate }}</h3>
        </div>
        <div class="card-body">
          @if (requestSent) {
            <p>{{ message }}</p>
          }
          <form [formGroup]="resetForm" novalidate>
            <!-- Email -->
            <div class="mb-3">
              <label class="form-label">{{ 'EMAIL' | translate }}</label>
              <input
                id="email"
                type="email"
                class="form-control"
                required
                formControlName="email"
              />
              <div
                *ngIf="resetForm.get('email')?.invalid && resetForm.get('email')?.touched"
                class="text-danger"
              >
                <small *ngIf="resetForm.get('email')?.errors?.['required']">{{
                  'EMAIL_REQUIRED' | translate
                }}</small>
                <small *ngIf="resetForm.get('email')?.errors?.['email']">{{
                  'ENTER_VALID_EMAIL' | translate
                }}</small>
              </div>
            </div>

            <!-- Submit -->
            <div class="mb-3 text-center">
              <button
                type="submit"
                class="btn btn-primary text-dark w-100"
                [disabled]="resetForm.invalid || loading || requestSent"
                (click)="requestReset()"
              >
                @if (loading) {
                  <app-loading
                    class="align-content-center"
                    [height]="20"
                    theme="dark"
                  ></app-loading>
                }
                {{ 'FORGET_PASSWORD_SEND_LINK' | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
